module.exports = __webpack_public_path__ + "static/img/10.571c196.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxclose/10.png
// module id = A4/w
// module chunks = 1